"use client"
/* */
const view = "flow--list--list-item-view--view";
const checkboxContainer = "flow--list--list-item-view--checkbox-container";
const content = "flow--list--list-item-view--content";
const topContent = "flow--list--list-item-view--top-content";
const bottomContent = "flow--list--list-item-view--bottom-content";
const heading = "flow--list--list-item-view--heading";
const header = "flow--list--list-item-view--header";
const subTitle = "flow--list--list-item-view--sub-title";
const text = "flow--list--list-item-view--text";
const badge = "flow--list--list-item-view--badge";
const listView = "flow--list--list-item-view--list-view";
const columnLayout = "flow--list--list-item-view--column-layout";
const contentWrapper = "flow--list--list-item-view--content-wrapper";
const title = "flow--list--list-item-view--title";
const action = "flow--list--list-item-view--action";
const avatar = "flow--list--list-item-view--avatar";
const tileView = "flow--list--list-item-view--tile-view";
const avatarContainer = "flow--list--list-item-view--avatar-container";
const styles = {
	view: view,
	checkboxContainer: checkboxContainer,
	content: content,
	topContent: topContent,
	bottomContent: bottomContent,
	heading: heading,
	header: header,
	subTitle: subTitle,
	text: text,
	badge: badge,
	listView: listView,
	columnLayout: columnLayout,
	contentWrapper: contentWrapper,
	title: title,
	action: action,
	avatar: avatar,
	tileView: tileView,
	avatarContainer: avatarContainer
};

export { action, avatar, avatarContainer, badge, bottomContent, checkboxContainer, columnLayout, content, contentWrapper, styles as default, header, heading, listView, subTitle, text, tileView, title, topContent, view };
//# sourceMappingURL=ListItemView.module.scss.mjs.map
